var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAutomatedMarketingBigImg = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    rx: 5,
    fill: "#E8F2FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12500_13299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57 32.6963V35.2138L39.4725 44.3654C38.5542 44.8404 37.4458 44.8404 36.5275 44.3654L19 35.2138V32.6963C19 31.3821 19.7283 30.1788 20.8842 29.5613L36.3217 21.3121C37.3667 20.7579 38.6333 20.7579 39.6783 21.3121L55.1158 29.5613C56.2717 30.1788 57 31.3821 57 32.6963Z",
    fill: "#556AE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.25 23.3542C52.25 20.9491 50.3009 19 47.8958 19H28.1042C25.6991 19 23.75 20.9491 23.75 23.3542V50.7775C23.75 51.433 24.282 51.965 24.9375 51.965H51.0625C51.718 51.965 52.25 51.433 52.25 50.7775V23.3542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 35.2129V51.8537C57 53.8171 55.4008 55.4162 53.4375 55.4162H22.5625C20.5992 55.4162 19 53.8171 19 51.8537V35.2129L36.5275 44.3646C37.4458 44.8396 38.5542 44.8396 39.4725 44.3646L57 35.2129Z",
    fill: "#6E83FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2291 38.4357C33.2658 38.4357 31.6666 36.8381 31.6666 34.8732C31.6666 33.6255 32.3237 32.4665 33.3814 31.8522C33.9482 31.5228 34.675 31.716 35.0043 32.2812C35.3336 32.8481 35.142 33.5748 34.5752 33.9042C34.2411 34.0989 34.0416 34.4615 34.0416 34.8732C34.0416 35.5287 34.5752 36.0607 35.2291 36.0607C35.883 36.0607 36.4166 35.5271 36.4166 34.8732C36.4166 34.7037 36.3834 34.5581 36.3169 34.4314C36.0113 33.8519 36.2314 33.1331 36.8109 32.8259C37.3888 32.5172 38.1076 32.7404 38.4164 33.3199C38.665 33.7917 38.7916 34.3142 38.7916 34.8732C38.7916 36.8381 37.1925 38.4357 35.2291 38.4357Z",
    fill: "#00D2A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3125 37.6814C46.2017 37.6814 46.0877 37.6656 45.9784 37.6339L29.3534 32.7667C28.8483 32.6179 28.5 32.154 28.5 31.6267V29.2517C28.5 28.7213 28.8515 28.2558 29.3613 28.1101L45.9863 23.3601C46.3426 23.2604 46.7321 23.3285 47.0266 23.5549C47.3258 23.7781 47.5 24.1296 47.5 24.5017V36.4939C47.5 36.8676 47.3242 37.2191 47.0234 37.4439C46.816 37.6006 46.5658 37.6814 46.3125 37.6814Z",
    fill: "#00D2A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3125 38.3558C45.657 38.3558 45.125 37.8238 45.125 37.1683V23.71C45.125 23.0545 45.657 22.5225 46.3125 22.5225C46.968 22.5225 47.5 23.0545 47.5 23.71V37.1683C47.5 37.8238 46.968 38.3558 46.3125 38.3558Z",
    fill: "#17ADA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6875 33.6058C29.032 33.6058 28.5 33.0738 28.5 32.4183V28.46C28.5 27.8045 29.032 27.2725 29.6875 27.2725C30.343 27.2725 30.875 27.8045 30.875 28.46V32.4183C30.875 33.0738 30.343 33.6058 29.6875 33.6058Z",
    fill: "#17ADA4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12500_13299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(19 19)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAutomatedMarketingBigImg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/automated_marketing_big_img.b16ae6b5ac1764e8864d202ec3f6ca90.svg";